import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import {
  REDUCER_NAME,
  RESET_COMPETITIONSPONSORS,
  SET_COMPETITIONSPONSORS,
  SET_ERROR,
} from "./constants";

const initialState = {
  isReady: false,
  isError: false,
  sponsors: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPETITIONSPONSORS:
      return {
        ...state,
        isReady: true,
        isError: false,
        sponsors: action.data,
      };
    case RESET_COMPETITIONSPONSORS:
      return initialState;
    case SET_ERROR:
      return {
        ...state,
        isReady: false,
        isError: true,
      };
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

export const selectIsReady = createSelector(getState, (n) => n.isReady);

export const selectIsError = createSelector(getState, (n) => n.isError);

export const selectCompetitionSponsors = createSelector(
  getState,
  (n) => n.sponsors
);

reducerRegistry.register(REDUCER_NAME, reducer);
